import React from 'react';
import { FaBriefcase, FaHandshake, FaUser, FaChartLine } from 'react-icons/fa';
import {
  ProfileCard,
  CardTitle,
  CardContent,
  ProposalList,
  ProposalItem,
  ProposalIcon,
  ProposalText
} from './styles';

const BusinessSection = () => {
  return (
    <ProfileCard>
      <CardTitle>Logros Empresariales</CardTitle>
      <CardContent>
        <ProposalList>
          <ProposalItem>
            <ProposalIcon><FaBriefcase /></ProposalIcon>
            <ProposalText>Dirección de MoviPort S.A., empresa logística con más de 35 años de experiencia</ProposalText>
          </ProposalItem>
          <ProposalItem>
            <ProposalIcon><FaHandshake /></ProposalIcon>
            <ProposalText>Especialización en servicios para cargas como fertilizantes, clinker, yeso y minerales</ProposalText>
          </ProposalItem>
          <ProposalItem>
            <ProposalIcon><FaUser /></ProposalIcon>
            <ProposalText>Creación y presidencia de la Fundación MoviPort</ProposalText>
          </ProposalItem>
          <ProposalItem>
            <ProposalIcon><FaChartLine /></ProposalIcon>
            <ProposalText>Desarrollo de una red de negocios consolidada en el sector privado</ProposalText>
          </ProposalItem>
        </ProposalList>
      </CardContent>
    </ProfileCard>
  );
};

export default BusinessSection;
